import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class PlsRegressionGraph extends AbstractScatterVisualization {
}
